<template>
  <div class="requirements-analysis" v-loading="loading">
    <!-- 需求部门分布 -->
    <el-card class="card">
      <PieChart
        title="需求部门分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.demand_department">
      </PieChart>
    </el-card>
    <!-- 素材类型分布 -->
    <el-card class="card">
      <PieChart
        title="素材类型分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.material_type">
      </PieChart>
    </el-card>
    <!-- 媒体分布 -->
    <el-card class="card">
      <PieChart
        title="媒体分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.media">
      </PieChart>
    </el-card>
    <!-- 产品标签分布 -->
    <el-card class="card">
      <MotherChildPieChart 
        title="产品标签分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.product_label">
      </MotherChildPieChart>
    </el-card>
    <!-- 工单标签分布 -->
    <el-card class="card">
      <PieChart
        title="工单标签分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.work_order_label">
      </PieChart>
    </el-card>
    <!-- 素材标签分布 -->
    <el-card class="card">
      <PieChart
        title="素材标签分布"
        subTitle="(工单创建时间)"
        :dataList="chartData.detail_material_label">
      </PieChart>
    </el-card>
    <!-- 特殊备注 -->
    <el-card class="card">
      <CloudChart :dataList="chartData.special_content"></CloudChart>
    </el-card>

    <!-- 预留空位 -->
    <el-card class="card" v-if="false"> </el-card>
    <el-card class="card" v-if="false"> </el-card>
  </div>
</template>
<script>
import { debounce } from "lodash"
import PieChart from "../components/PieChart.vue"
import CloudChart from "./CloudChart.vue"
import MotherChildPieChart from "./motherChildPieChart.vue"
import API from "@/api/workOrder/board.js"
export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PieChart,
    CloudChart,
    MotherChildPieChart,
  },

  data() {
    return {
      loading: false,
      chartData: {
        demand_department: [], // 需求部门分布
        material_type: [], //素材类型分布
        media: [], // 媒体分布
        product_label: {}, //产品标签分布
        work_order_label: [], // 工单标签分布
        detail_material_label: [], //素材标签分布
        special_content: [], // 特殊备注
      },
    }
  },
  watch: {
    form: {
      handler: debounce(function (newVal, oldVal) {
        this.loading = true
        let params = {
          ...this.form,
          range_time:
            this.form.range_time?.length > 0
              ? this.form?.range_time.join("/")
              : "",
        }
        API.getRequirementAnalysis(params).then((res) => {
          if (res.code === 200) {
            this.loading = false
            this.chartData.demand_department = res.data.demand_department // 需求部门分布
            this.chartData.material_type = res.data.material_type //素材类型分布
            this.chartData.media = res.data.media // 媒体分布
            this.chartData.product_label = res.data.product_label //产品标签分布
            this.chartData.work_order_label = res.data.work_order_label // 工单标签分布
            this.chartData.detail_material_label =
              res.data.detail_material_label //素材标签分布
            this.chartData.special_content = res.data.special_content
          }
        })
      },500),
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
.requirements-analysis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .card {
    width: 33%;
    margin-bottom: 20px;
  }
  ::v-deep(.el-card__header) {
    border-bottom: 0 !important;
    padding: 15px;
  }
  ::v-deep(.el-card__body) {
    padding: 16px;
  }
}
</style>
